export default function Anno() {
  return <>Anno</>;
}
